import * as _m0 from "protobufjs/minimal";
import { Long } from "@osmonauts/helpers";
function createBaseParams_ZoneComAddressEntry() {
  return {
    key: "",
    value: ""
  };
}
export const Params_ZoneComAddressEntry = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams_ZoneComAddressEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$key, _object$value;
    const message = createBaseParams_ZoneComAddressEntry();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : "";
    message.value = (_object$value = object.value) !== null && _object$value !== void 0 ? _object$value : "";
    return message;
  }
};
function createBaseParams() {
  return {
    rewardsInterval: Long.UZERO,
    delegateInterval: Long.UZERO,
    depositInterval: Long.UZERO,
    redemptionRateInterval: Long.UZERO,
    strideCommission: Long.UZERO,
    zoneComAddress: {},
    reinvestInterval: Long.UZERO,
    validatorRebalancingThreshold: Long.UZERO,
    icaTimeoutNanos: Long.UZERO,
    bufferSize: Long.UZERO,
    ibcTimeoutBlocks: Long.UZERO,
    feeTransferTimeoutNanos: Long.UZERO,
    maxStakeIcaCallsPerEpoch: Long.UZERO,
    safetyMinRedemptionRateThreshold: Long.UZERO,
    safetyMaxRedemptionRateThreshold: Long.UZERO,
    ibcTransferTimeoutNanos: Long.UZERO,
    safetyNumValidators: Long.UZERO,
    safetyMaxSlashPercent: Long.UZERO
  };
}
export const Params = {
  encode(message, writer = _m0.Writer.create()) {
    if (!message.rewardsInterval.isZero()) {
      writer.uint32(8).uint64(message.rewardsInterval);
    }
    if (!message.delegateInterval.isZero()) {
      writer.uint32(48).uint64(message.delegateInterval);
    }
    if (!message.depositInterval.isZero()) {
      writer.uint32(16).uint64(message.depositInterval);
    }
    if (!message.redemptionRateInterval.isZero()) {
      writer.uint32(24).uint64(message.redemptionRateInterval);
    }
    if (!message.strideCommission.isZero()) {
      writer.uint32(32).uint64(message.strideCommission);
    }
    Object.entries(message.zoneComAddress).forEach(([key, value]) => {
      Params_ZoneComAddressEntry.encode({
        key: key,
        value
      }, writer.uint32(42).fork()).ldelim();
    });
    if (!message.reinvestInterval.isZero()) {
      writer.uint32(56).uint64(message.reinvestInterval);
    }
    if (!message.validatorRebalancingThreshold.isZero()) {
      writer.uint32(64).uint64(message.validatorRebalancingThreshold);
    }
    if (!message.icaTimeoutNanos.isZero()) {
      writer.uint32(72).uint64(message.icaTimeoutNanos);
    }
    if (!message.bufferSize.isZero()) {
      writer.uint32(80).uint64(message.bufferSize);
    }
    if (!message.ibcTimeoutBlocks.isZero()) {
      writer.uint32(88).uint64(message.ibcTimeoutBlocks);
    }
    if (!message.feeTransferTimeoutNanos.isZero()) {
      writer.uint32(96).uint64(message.feeTransferTimeoutNanos);
    }
    if (!message.maxStakeIcaCallsPerEpoch.isZero()) {
      writer.uint32(104).uint64(message.maxStakeIcaCallsPerEpoch);
    }
    if (!message.safetyMinRedemptionRateThreshold.isZero()) {
      writer.uint32(112).uint64(message.safetyMinRedemptionRateThreshold);
    }
    if (!message.safetyMaxRedemptionRateThreshold.isZero()) {
      writer.uint32(120).uint64(message.safetyMaxRedemptionRateThreshold);
    }
    if (!message.ibcTransferTimeoutNanos.isZero()) {
      writer.uint32(128).uint64(message.ibcTransferTimeoutNanos);
    }
    if (!message.safetyNumValidators.isZero()) {
      writer.uint32(136).uint64(message.safetyNumValidators);
    }
    if (!message.safetyMaxSlashPercent.isZero()) {
      writer.uint32(144).uint64(message.safetyMaxSlashPercent);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.rewardsInterval = reader.uint64();
          break;
        case 6:
          message.delegateInterval = reader.uint64();
          break;
        case 2:
          message.depositInterval = reader.uint64();
          break;
        case 3:
          message.redemptionRateInterval = reader.uint64();
          break;
        case 4:
          message.strideCommission = reader.uint64();
          break;
        case 5:
          const entry5 = Params_ZoneComAddressEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.zoneComAddress[entry5.key] = entry5.value;
          }
          break;
        case 7:
          message.reinvestInterval = reader.uint64();
          break;
        case 8:
          message.validatorRebalancingThreshold = reader.uint64();
          break;
        case 9:
          message.icaTimeoutNanos = reader.uint64();
          break;
        case 10:
          message.bufferSize = reader.uint64();
          break;
        case 11:
          message.ibcTimeoutBlocks = reader.uint64();
          break;
        case 12:
          message.feeTransferTimeoutNanos = reader.uint64();
          break;
        case 13:
          message.maxStakeIcaCallsPerEpoch = reader.uint64();
          break;
        case 14:
          message.safetyMinRedemptionRateThreshold = reader.uint64();
          break;
        case 15:
          message.safetyMaxRedemptionRateThreshold = reader.uint64();
          break;
        case 16:
          message.ibcTransferTimeoutNanos = reader.uint64();
          break;
        case 17:
          message.safetyNumValidators = reader.uint64();
          break;
        case 18:
          message.safetyMaxSlashPercent = reader.uint64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$zoneComAddres;
    const message = createBaseParams();
    message.rewardsInterval = object.rewardsInterval !== undefined && object.rewardsInterval !== null ? Long.fromValue(object.rewardsInterval) : Long.UZERO;
    message.delegateInterval = object.delegateInterval !== undefined && object.delegateInterval !== null ? Long.fromValue(object.delegateInterval) : Long.UZERO;
    message.depositInterval = object.depositInterval !== undefined && object.depositInterval !== null ? Long.fromValue(object.depositInterval) : Long.UZERO;
    message.redemptionRateInterval = object.redemptionRateInterval !== undefined && object.redemptionRateInterval !== null ? Long.fromValue(object.redemptionRateInterval) : Long.UZERO;
    message.strideCommission = object.strideCommission !== undefined && object.strideCommission !== null ? Long.fromValue(object.strideCommission) : Long.UZERO;
    message.zoneComAddress = Object.entries((_object$zoneComAddres = object.zoneComAddress) !== null && _object$zoneComAddres !== void 0 ? _object$zoneComAddres : {}).reduce((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = String(value);
      }
      return acc;
    }, {});
    message.reinvestInterval = object.reinvestInterval !== undefined && object.reinvestInterval !== null ? Long.fromValue(object.reinvestInterval) : Long.UZERO;
    message.validatorRebalancingThreshold = object.validatorRebalancingThreshold !== undefined && object.validatorRebalancingThreshold !== null ? Long.fromValue(object.validatorRebalancingThreshold) : Long.UZERO;
    message.icaTimeoutNanos = object.icaTimeoutNanos !== undefined && object.icaTimeoutNanos !== null ? Long.fromValue(object.icaTimeoutNanos) : Long.UZERO;
    message.bufferSize = object.bufferSize !== undefined && object.bufferSize !== null ? Long.fromValue(object.bufferSize) : Long.UZERO;
    message.ibcTimeoutBlocks = object.ibcTimeoutBlocks !== undefined && object.ibcTimeoutBlocks !== null ? Long.fromValue(object.ibcTimeoutBlocks) : Long.UZERO;
    message.feeTransferTimeoutNanos = object.feeTransferTimeoutNanos !== undefined && object.feeTransferTimeoutNanos !== null ? Long.fromValue(object.feeTransferTimeoutNanos) : Long.UZERO;
    message.maxStakeIcaCallsPerEpoch = object.maxStakeIcaCallsPerEpoch !== undefined && object.maxStakeIcaCallsPerEpoch !== null ? Long.fromValue(object.maxStakeIcaCallsPerEpoch) : Long.UZERO;
    message.safetyMinRedemptionRateThreshold = object.safetyMinRedemptionRateThreshold !== undefined && object.safetyMinRedemptionRateThreshold !== null ? Long.fromValue(object.safetyMinRedemptionRateThreshold) : Long.UZERO;
    message.safetyMaxRedemptionRateThreshold = object.safetyMaxRedemptionRateThreshold !== undefined && object.safetyMaxRedemptionRateThreshold !== null ? Long.fromValue(object.safetyMaxRedemptionRateThreshold) : Long.UZERO;
    message.ibcTransferTimeoutNanos = object.ibcTransferTimeoutNanos !== undefined && object.ibcTransferTimeoutNanos !== null ? Long.fromValue(object.ibcTransferTimeoutNanos) : Long.UZERO;
    message.safetyNumValidators = object.safetyNumValidators !== undefined && object.safetyNumValidators !== null ? Long.fromValue(object.safetyNumValidators) : Long.UZERO;
    message.safetyMaxSlashPercent = object.safetyMaxSlashPercent !== undefined && object.safetyMaxSlashPercent !== null ? Long.fromValue(object.safetyMaxSlashPercent) : Long.UZERO;
    return message;
  }
};